import { Controller } from "@hotwired/stimulus"
import * as Log from "web-ui/log"

const animationDelayMilliseconds = 500;

// Connects to data-controller="modal-dialog"
export default class extends Controller {
  connect() {
    this.debug("Connect")

    this.element.showModal()
    this.element.addEventListener("close", this.closeAndRemove)
  }

  disconnect() {
    this.debug("Disconnect")

    this.element.removeEventListener("close", this.closeAndRemove)
  }

  closeAndRemove = () => {
    this.close()
    setTimeout(() => this.remove(), animationDelayMilliseconds)
  }

  close() {
    this.element.close()
  }

  remove() {
    this.element.remove()
  }

  debug(message, data) {
    Log.debug("Modal Dialog - " + message, data)
  }
}
